import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import Select from 'react-select'
import LinesEllipsis from 'react-lines-ellipsis'

import testPhoto from "../../assets/images/reviews/garil.jpg";

class SearchItem extends Component {

  render() {
    var unavailable = <div>available</div>
    if (this.props.vacation == 1)
    {
      unavailable = <div>Unavailable</div>
    }
    return (
      <React.Fragment>
        <a href={this.props.destination} className="card rounded-0 border-left-0 border-top-0 border-right-0 border-bottom derma-listing-item">
          <div className="card-body pb-0 pt-4 pb-2 mt-0 mb-0 d-none d-md-block">
              <div className="media derma-listing-item">
                  <img className="d-flex mr-3 rounded-circle img-thumbnail thumb-lg" src={this.props.photo} alt={this.props.name} style={{height: 107, width: 107, maxWidth: 107}} />
                  <div className="media-body">
                      <h5 className="text-dark-gray mt-0 font-weight-bold font-18 mb-1">{this.props.name}</h5>
                      <p className="text-dark-gray font-12 mb-0">{this.props.category}</p>
                      <p className="text-muted font-14">{this.props.address}</p>
                      <LinesEllipsis className="text-muted font-14" maxLine="2" text={this.props.blurp} />
                  </div>
                  <div className="float-right">
                    <div className="btn btn-outline-derma">View</div>
                  </div>

              </div>
          </div>

          <div className="card-body pb-0 pt-4 pb-2 mt-0 mb-0 d-md-none">
              <div className="row media derma-listing-item">
                  <img className="d-flex mr-3 rounded-circle thumb-sm" src={this.props.photo} alt={this.props.name} style={{height: 78, width: 78, maxWidth: 78}} />
                  <div className="media-body">
                      <h6 className="text-dark-gray mt-0 font-weight-bold font-16 mb-1">{this.props.name}</h6>
                      <p className="text-dark-gray text-sub-small mb-0">{this.props.category}</p>
                      <p className="text-muted search-item-address">{this.props.address}</p>
                      <div className="btn btn-outline-derma pt-1 pb-1" style={{fontSize: 12}}>View</div>
                  </div>
              </div>
          </div>
        </a>
      </React.Fragment>
    );
  }
}

export default SearchItem;
